// extracted by mini-css-extract-plugin
export default {"header":"PecaHeader_header__U7loN","pecaName":"PecaHeader_pecaName__La5QB","title":"PecaHeader_title__HiOa9"};